const paymentTermsSelectorElementEdit = document.getElementById('test-payment-terms-selector');
const formDataEdit = document.getElementById('form-data');

paymentTermsSelectorElementEdit.addEventListener('outputPaymentTermForm', function(event) {
  if ((event as any).detail) {
    formDataEdit.innerText = JSON.stringify((event as any).detail);
  }
});
